import type { DataTableColumn } from '@/components/custom/erp';
import type { Group } from '@/types/schemas';

export const itemGroupColumns: DataTableColumn<Group>[] = [
  {
    field: 'ma_nhom',
    headerName: 'Mã nhóm',
    width: 200
  },
  { field: 'ten_phan_nhom', headerName: 'Tên nhóm', width: 350, flex: 1 }
];

export const itemGroupDetailColumns: DataTableColumn<Group>[] = [
  { field: 'ma_nhom', headerName: 'Mã nhóm', width: 200 },
  { field: 'ten_phan_nhom', headerName: 'Tên nhóm', width: 350, flex: 1 }
];
